import { api, apiFetch } from './client';
import type { LoginEventDto, Role, TeamMemberDto } from './types';

export function listMembers(): Promise<{ members: TeamMemberDto[] }> {
  return api.get('/api/v1/team/members');
}

export interface CreateMemberBody {
  email: string;
  name: string;
  role: Role;
  channel_access?: string[];
}

/** `temp_password` is returned exactly once — the server keeps only its hash. */
export interface CreatedMember {
  id: string;
  email: string;
  name: string;
  role: Role;
  temp_password: string;
}

export function createMember(body: CreateMemberBody): Promise<CreatedMember> {
  return api.post('/api/v1/team/members', body);
}

export function resetMemberPassword(userId: string): Promise<{ userId: string; temp_password: string }> {
  return api.post(`/api/v1/team/members/${userId}/reset-password`);
}

export function setMemberDisabled(userId: string, disabled: boolean): Promise<{ userId: string; disabledAt: string | null }> {
  return api.post(`/api/v1/team/members/${userId}/${disabled ? 'disable' : 'enable'}`);
}

export function listLoginEvents(userId?: string): Promise<{ items: LoginEventDto[] }> {
  return api.get('/api/v1/team/login-events', { user_id: userId });
}

export interface PatchMemberBody {
  role?: Role;
  channel_access?: string[];
}

export function patchMember(
  userId: string,
  body: PatchMemberBody,
): Promise<{ userId: string; role: Role; channelIds: string[] }> {
  return api.patch(`/api/v1/team/members/${userId}`, body);
}

export function removeMember(userId: string): Promise<void> {
  return apiFetch<void>(`/api/v1/team/members/${userId}`, { method: 'DELETE' });
}
